import React, { useState } from "react";
import AdminBookingTool from "../AdminScheduling/SchedulingComponents/AdminBookingTool";
import AdminAvailabilityTool from "../NewAdminScheduling/components/AdminAvailabilityTool";
import "./AdminSchedulingWrapper.css";

const AdminSchedulingWrapper = ({ user }) => {
  const [isAdvancedMode, setIsAdvancedMode] = useState(true);

  const handleToggle = () => {
    setIsAdvancedMode((prev) => !prev);
  };

  return (
    <div className="admin-scheduling-wrapper">
      <div className="toggle-header">
        <button className="toggle-button" onClick={handleToggle}>
          {isAdvancedMode ? "Switch to Advanced Mode" : "Switch to Basic Mode"}
        </button>
      </div>

      <div className="scheduling-body">
        {isAdvancedMode ? (
          <AdminAvailabilityTool user={user} />
        ) : (
          <AdminBookingTool user={user} />
        )}
      </div>
    </div>
  );
};

export default AdminSchedulingWrapper;
